import {useContext} from 'react'

import PropTypes from 'prop-types'

import {useDecision} from '@s-ui/pde'
import Context from '@s-ui/react-context'
import {AuthenticationContext} from '@adv-mt/mt-context-authentication'
import {Checkbox} from '@adv-mt/ui/checkbox'
import {Field} from '@adv-mt/ui/field'
import {Body2} from '@adv-mt/ui/typography'

import {useFormContext} from '../form/formContexts.js'
import {V2_FIELDS} from '../schema/contactSchema.js'
import {BASE_CLASS} from './FormFields.js'

const ALERTS_ID = 'contact-form-v2-alerts'

export const ALERTS_FLAG_KEY = 'ff_web_growth_checkbox_enable_alerts_on_lead'

const AlertsCheckbox = ({pageName}) => {
  const {i18n, domain} = useContext(Context)
  const form = useFormContext()
  const {isLogged} = useContext(AuthenticationContext)
  const {enabled: isFlagEnabled} = useDecision(ALERTS_FLAG_KEY, {
    attributes: {page_name: pageName, is_logged_in: isLogged, isContactFromPricedropEmail: false}
  })
  const {HAS_ALERTS_ON_LEAD_ENABLED} = domain.get('config').get('features')

  const canCreateAlert = isFlagEnabled && isLogged && HAS_ALERTS_ON_LEAD_ENABLED

  if (!canCreateAlert) {
    return null
  }

  return (
    <form.Field name={V2_FIELDS.ENABLE_ALERTS}>
      {field => (
        <Field.Root className={`${BASE_CLASS}-alerts`}>
          <Checkbox
            id={ALERTS_ID}
            name={field.name}
            checked={field.state.value}
            onCheckedChange={checked => field.handleChange(checked)}
          />
          <Field.Label htmlFor={ALERTS_ID}>
            <Body2 as="span">{i18n.t('FORM.ENABLE_ALERTS_CHECKBOX')}</Body2>
          </Field.Label>
        </Field.Root>
      )}
    </form.Field>
  )
}

AlertsCheckbox.displayName = 'ContactFormV2AlertsCheckbox'

AlertsCheckbox.propTypes = {
  pageName: PropTypes.string
}

export default AlertsCheckbox
